export const ACTIONS_MACHINE = {
  INVALIDATE: 'MACHINES_INVALIDATE',
  RECEIVE: 'MACHINES_RECEIVE',
  DELETE: 'MACHINE_DELETE',
  UPDATE: 'MACHINE_UPDATE',
};

const machineConstants = {};

export default machineConstants;
